<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col cols="12">
                    <div>
                        <p class="font-weight-bold">C. FEES AND CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE</p>
                    </div>
                    <div>
                        <p>The following fees and charges reflect the information during your application process.</p>
                    </div>
                    <b-table-simple responsive striped hover class="text-sm text-md-md">
                        <b-tbody>
                            <b-tr v-for="(item, j) in data" :key="j" class="py-2 py-md-3">
                                <b-td class="font-weight-bold" style="width: 40%;">{{ item.key }}</b-td>
                                <b-td>
                                    <span v-html="item.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div class="mt-3">
                        <p>Tuition typically increases by no more than 3% each academic year. Mandatory semester fees increase every two years.</p>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-exchange-c"
                                        v-model="form.status"
                                        name="checkbox-exchange-c"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    />
                                    <div>
                                        I read and confirm that I understand the information in Section C.
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button type="submit" @click="next" variant="primary" class="w-100 w-md-auto">
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
    props: {
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            form: {},
            data: []
        }
    },
    created() {
        this.getData()
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            const info = this.studentInformation || {};
            const admDep = info.admission_confirmation_deposit ? `$${info.admission_confirmation_deposit}` : '$ xxx';
            const tuiDep = info.tuition_deposit ? `$${info.tuition_deposit}` : '$ xxx';
            const tuiCred = info.tuition_per_credit ? `$${info.tuition_per_credit}` : '$ xxx';

            this.data = [
                {
                    key: 'Admission Confirmation Deposit:',
                    value: `${admDep} - Non Refundable (but credited towards tuition).`,
                },
                {
                    key: 'OTHER FEES MAY APPLY:',
                    value: `For example, requests by students for official university documents (e.g., requests for transcripts, enrollment verifications and academic records) may require payment of the relevant fee(s). Information about the above-mentioned university fees and other fees can be found on Bay Atlantic University’s website at <a href="https://bau.edu/admissions/tuition-fees/" target="_blank">https://bau.edu/admissions/tuition-fees/</a>.`,
                },
            ]
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
